/* eslint-disable react/no-array-index-key */
import { useCallback, useEffect, useState } from 'react';

import { IoIosArrowBack } from 'react-icons/io';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts';

import { ExplainDate, Layout } from '~/components';
import { useAuth } from '~/hooks/auth';
import api from '~/services/api';

import { ITecnical } from '../../types';

import * as S from '../styles';

const months = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Maio',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

const CommercialReports = () => {
  const { goBack } = useHistory();
  const {
    user: { professional },
  } = useAuth();

  const {
    state: { startDate, endDate },
  } = useLocation<any>();

  const [trainingIssued, setTrainingIssued] = useState<any>([]);
  const [trainingIssuedTotal, setTrainingIssuedTotal] = useState<any>([]);
  const [countClassification, setCountClassification] = useState<any>([]);
  const [countStudentLevel, setCountStudentLevel] = useState<any>([]);
  const [countObjectives, setCountObjectives] = useState<any>([]);
  const [countDatasheetsfrequency, setCountDatasheetsfrequency] = useState<any>(
    [],
  );
  const [countDatasheetsTimeAvaiable, setCountDatasheetsTimeAvaiable] =
    useState<any>([]);

  const getComercialReports = useCallback(async () => {
    try {
      const { data } = await api.get<ITecnical>(
        `/reports/${professional.id}/tecnical-manangements`,
        {
          params: {
            startDate,
            endDate,
          },
        },
      );
      // console.log('startDate:', startDate);
      // console.log('endDate:', endDate);

      const trainingIssuedFormattedData = months.map((month, index) => {
        const monthTrainingIssued =
          data.countTrainingManagementsByStatus.filter(
            (trainningIssued) =>
              parseInt(trainningIssued.month, 10) === index + 1,
          );

        const emited = monthTrainingIssued
          .filter((filterData) => filterData.status === 'emited')
          .reduce(
            (acc: any, reduceData) => acc + parseInt(reduceData.count, 10),
            0,
          );

        return {
          month,
          emited,
        };
      });
      setTrainingIssued(trainingIssuedFormattedData);

      const trainingIssuedTotalFormattedData = months.map((month, index) => {
        const monthTrainingIssued =
          data.countTrainingManagementsByStatus.filter(
            (trainningIssued) =>
              parseInt(trainningIssued.month, 10) === index + 1,
          );

        const emited = monthTrainingIssued
          .filter((filterData) => filterData.status === 'emited')
          .reduce(
            (acc: any, reduceData) => acc + parseInt(reduceData.count, 10),
            0,
          );

        const pending = monthTrainingIssued
          .filter((filterData) => filterData.status === 'pending')
          .reduce(
            (acc: any, reduceData) => acc + parseInt(reduceData.count, 10),
            0,
          );

        const expired = monthTrainingIssued
          .filter((filterData) => filterData.status === 'expired')
          .reduce(
            (acc: any, reduceData) => acc + parseInt(reduceData.count, 10),
            0,
          );

        const canceled = monthTrainingIssued
          .filter((filterData) => filterData.status === 'canceled')
          .reduce(
            (acc: any, reduceData) => acc + parseInt(reduceData.count, 10),
            0,
          );

        return {
          month,
          emited,
          pending,
          expired,
          canceled,
        };
      });
      setTrainingIssuedTotal(trainingIssuedTotalFormattedData);

      setCountClassification(data.countDatasheets);

      setCountStudentLevel(data.countDatasheetsStudentLevel);

      setCountObjectives(data.countDatasheetsObjective);

      setCountDatasheetsfrequency(data.countDatasheetsfrequency);

      setCountDatasheetsTimeAvaiable(data.countDatasheetsTimeAvaiable);
    } catch (error) {
      console.log('error:', error);
      toast.error('Houve um erro ao buscar os dados dos gráficos');
    }
  }, [startDate, endDate, professional]);

  useEffect(() => {
    getComercialReports();
  }, [getComercialReports]);

  return (
    <Layout title="I.BOSS">
      <S.Header>
        <S.HeaderWrapper onClick={() => goBack()}>
          <IoIosArrowBack color="#FFDF22" size={24} />
          <S.HeaderLabel>Gestão Técnica</S.HeaderLabel>
        </S.HeaderWrapper>

        <ExplainDate initial={startDate || ''} last={endDate || ''} />
      </S.Header>

      <S.Container>
        <S.ChartContainer>
          <S.ChartTitle>
            Programa de treino - Emissão (emitidos no ano/mês)
          </S.ChartTitle>

          <BarChart
            width={730}
            height={250}
            data={trainingIssued}
            maxBarSize={25}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip
              labelStyle={{ color: '#000000' }}
              itemStyle={{ color: '#000000' }}
            />
            <Legend />
            <Bar dataKey="emited" stackId="a" name="Emitido" fill="#04c230" />
          </BarChart>
        </S.ChartContainer>

        <S.ChartContainer>
          <S.ChartTitle>
            Programa de treino - Emissão, Pendências e Cancelados (emitidos no
            ano/mês)
          </S.ChartTitle>
          <BarChart
            width={730}
            height={250}
            data={trainingIssuedTotal}
            maxBarSize={25}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip
              labelStyle={{ color: '#000000' }}
              itemStyle={{ color: '#000000' }}
            />
            <Legend />
            <Bar dataKey="emited" stackId="a" name="Emitido" fill="#04c230" />
            <Bar dataKey="pending" stackId="a" name="Pendente" fill="#FFDF22" />
            <Bar dataKey="expired" stackId="a" name="Expirado" fill="#d90606" />
            <Bar dataKey="canceled" stackId="a" name="Cancelado" fill="blue" />
          </BarChart>
        </S.ChartContainer>

        <S.ChartContainer>
          <S.ChartTitle>Avaliação corporal</S.ChartTitle>
          <BarChart
            width={730}
            height={250}
            data={countClassification}
            maxBarSize={25}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="classification" />
            <YAxis />
            <Tooltip
              labelStyle={{ color: '#000000' }}
              itemStyle={{ color: '#000000' }}
            />
            <Legend />
            <Bar dataKey="count" name="Quantidade" fill="#FFDF22" />
          </BarChart>
        </S.ChartContainer>

        <S.ChartContainer>
          <S.ChartTitle>Nível Técnico</S.ChartTitle>
          <BarChart
            width={730}
            height={250}
            data={countStudentLevel}
            maxBarSize={25}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="student_level" />
            <YAxis />
            <Tooltip
              labelStyle={{ color: '#000000' }}
              itemStyle={{ color: '#000000' }}
            />
            <Legend />
            <Bar dataKey="count" name="Quantidade" fill="#FFDF22" />
          </BarChart>
        </S.ChartContainer>

        <S.ChartContainer>
          <S.ChartTitle>Objetivo</S.ChartTitle>
          <BarChart
            width={730}
            height={250}
            data={countObjectives}
            maxBarSize={25}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="objective" />
            <YAxis />
            <Tooltip
              labelStyle={{ color: '#000000' }}
              itemStyle={{ color: '#000000' }}
            />
            <Legend />
            <Bar dataKey="count" name="Quantidade" fill="#FFDF22" />
          </BarChart>
        </S.ChartContainer>

        <S.ChartContainer>
          <S.ChartTitle>Frequência</S.ChartTitle>
          <BarChart
            width={730}
            height={250}
            data={countDatasheetsfrequency}
            maxBarSize={25}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="frequency" />
            <YAxis />
            <Tooltip
              labelStyle={{ color: '#000000' }}
              itemStyle={{ color: '#000000' }}
            />
            <Legend />
            <Bar dataKey="count" name="Quantidade" fill="#FFDF22" />
          </BarChart>
        </S.ChartContainer>

        <S.ChartContainer>
          <S.ChartTitle>Tempo disponível</S.ChartTitle>
          <BarChart
            width={730}
            height={250}
            data={countDatasheetsTimeAvaiable}
            maxBarSize={25}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="available_time" />
            <YAxis />
            <Tooltip
              labelStyle={{ color: '#000000' }}
              itemStyle={{ color: '#000000' }}
            />
            <Legend />
            <Bar dataKey="count" name="Quantidade" fill="#FFDF22" />
          </BarChart>
        </S.ChartContainer>
      </S.Container>
    </Layout>
  );
};

export default CommercialReports;
